module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"tooltip":"Wykres prezentuje liczbę ofert w sklepach wyświetlanych w widgecie (domyślne ustawienia). Aby sprawdzić liczbę ofert w pozostałych sklepach, użyj filtra Sklep."}}')
  delete Component.options._Ctor
}
